import React, { memo } from "react";

import { IAppRoute } from "components/common/app-routes/types";
import { NotFoundContainer } from "components/not-found-container";
import { BusinessesProvider } from "contexts/businesses-context";
import { BusinessDetailsTabStatus } from "features/businesses/business-details/consts";
import { IndividualDetailsTabStatus } from "features/individuals/individual-details/consts";
import {
  CreateNewPasswordPage,
  ForgotPasswordPage,
  LoginPage,
  VerifyPasswordPage,
} from "pages/auth/Loadable";
import { BusinessCompliancePageLazy } from "pages/business-compliance/Loadable";
import {
  BusinessTransactionPageLazy, // BusinessTransactionsDetailsPageLazy,
} from "pages/business-transactions/Loadable";
import {
  BusinessesFixedDepositsDetailsPageLazy,
  BusinessesFixedDepositsHistoryPageLazy,
  BusinessesSavingsPageLazy,
  BusinessesVaultSavingsDetailsPageLazy,
  BusinessesVaultSavingsHistoryPageLazy,
} from "pages/businesses-savings/Loadable";
import {
  AddNewBusinessPageLazy,
  BusinessDetailsAccountTransactionsPageLazy,
  BusinessDetailsMainPageLazy,
  BusinessTransactionLimitsPageLazy,
  BusinessesPageLazy,
  ContinueBusinessRegistrationPageLazy,
  UpdateBusinessTypePageLazy,
} from "pages/businesses/Loadable";
import { IBusinessDetailsMainPageProps } from "pages/businesses/business-details/types";
import { IndividualCompliancePageLazy } from "pages/individual-compliance/Loadable";
import { IndividualTransactionsPageLazy } from "pages/individual-transactions/Loadable";
import {
  IndividualsSavingsFlexViewDetailsPageLazy,
  IndividualsSavingsFlexViewHistoryPageLazy,
  IndividualsSavingsGoalViewDetailsPageLazy,
  IndividualsSavingsGoalViewHistoryPageLazy,
  IndividualsSavingsPageLazy,
  IndividualsSavingsVaultViewDetailsPageLazy,
  IndividualsSavingsVaultViewHistoryPageLazy,
} from "pages/individuals-savings/Loadable";
// import { IndividualTransactionsDetailsPageLazy } from "pages/individual-transactions/Loadable";
import {
  // IndividualAccountDetailsPageLazy,
  IndividualAccountTransactionDetailsPageLazy,
  IndividualAccountViewTransactionDetailsPageLazy,
  IndividualDetailsMainPageLazy,
  IndividualTransactionsViewTransactionDetailsPageLazy, // IndividualDetailsPageLazy,
  // IndividualLoansDetailsPageLazy,
  // IndividualOnDemandPayDetailsPageLazy,
  // IndividualSavingsDetailsPageLazy,
  // IndividualTransactionsDetailsPageLazy,
  IndividualViewLoanDetailsPageLazy,
  IndividualViewSavingDetailsPageLazy,
  IndividualViewSavingsHistoryPageLazy,
  IndividualViewWithdrawalHistoryPageLazy,
  IndividualsPageLazy,
} from "pages/individuals/Loadable";
import { IIndividualDetailsMainPageProps } from "pages/individuals/individual-details/types";
// import { IIndividualDetailsMainPageProps } from "pages/individuals/individual-details/types";
import { TransactionsPageLazy } from "pages/transactions/Loadable";
import { TransactionsDetailsPageLazy } from "pages/transactions/Loadable";
// import { DashboardPage } from "pages/dashboard/Loadable";
import { UiComponentsDemoPage } from "pages/ui-components-demo/Loadable";

import { ROUTES, ROUTES_BASE } from "./constants";

const removeBasePathFromRoute = (
  basePath: ROUTES_BASE,
  route: string
): string => {
  return route.replace(basePath, "");
};

export const AUTH_ROUTES: IAppRoute[] = [
  {
    path: removeBasePathFromRoute(
      ROUTES_BASE.AUTH,
      ROUTES.CREATE_PASSWORD_PAGE
    ),
    element: <CreateNewPasswordPage />,
  },
  {
    path: removeBasePathFromRoute(
      ROUTES_BASE.AUTH,
      ROUTES.FORGOT_PASSWORD_PAGE
    ),
    element: <ForgotPasswordPage />,
  },
  {
    path: removeBasePathFromRoute(
      ROUTES_BASE.AUTH,
      ROUTES.VERIFY_PASSWORD_PAGE
    ),
    element: <VerifyPasswordPage />,
  },
  {
    path: removeBasePathFromRoute(ROUTES_BASE.AUTH, ROUTES.LOGIN_PAGE),
    element: <LoginPage />,
  },
  {
    path: "*",
    element: <NotFoundContainer />,
  },
];

// export const DASHBOARD_ROUTES: IAppRoute[] = [
//   {
//     path: removeBasePathFromRoute(ROUTES_BASE.DASHBOARD, ROUTES.DASHBOARD_PAGE),
//     element: <DashboardPage />,
//   },
// ];

export const UICOMPONENTS_DEMO_ROUTES: IAppRoute[] = [
  {
    path: removeBasePathFromRoute(
      ROUTES_BASE.UI_COMPONENTS_DEMO,
      ROUTES.UI_COMPONENTS_DEMO_PAGE
    ),
    element: <UiComponentsDemoPage />,
  },
  {
    path: removeBasePathFromRoute(
      ROUTES_BASE.UI_COMPONENTS_DEMO,
      ROUTES.UI_COMPONENTS_DEMO_APPROVED_PAGE
    ),
    element: <UiComponentsDemoPage />,
  },
  {
    path: removeBasePathFromRoute(
      ROUTES_BASE.UI_COMPONENTS_DEMO,
      ROUTES.UI_COMPONENTS_DEMO_REJECTED_PAGE
    ),
    element: <UiComponentsDemoPage />,
  },
];

const TransactionsPageRoute = memo(() => <TransactionsPageLazy />);
const IndividualTransactionsPageRoute = memo(() => (
  <IndividualTransactionsPageLazy />
));
const BusinessTransactionPageRoute = memo(() => (
  <BusinessTransactionPageLazy />
));
const TransactionsDetailsPageRoute = memo(() => (
  <TransactionsDetailsPageLazy />
));
// const BusinessTransactionsDetailsPageRoute = memo(() => (
//   <BusinessTransactionsDetailsPageLazy />
// ));
// const IndividualTransactionsDetailsPageRoute = memo(() => (
//   <IndividualTransactionsDetailsPageLazy />
// ));
export const TRANSACTIONS_ROUTES: IAppRoute[] = [
  {
    path: removeBasePathFromRoute(
      ROUTES_BASE.TRANSACTIONS,
      ROUTES.TRANSACTIONS_PAGE_ALL
    ),
    element: <TransactionsPageRoute />,
  },
  {
    path: removeBasePathFromRoute(
      ROUTES_BASE.TRANSACTIONS,
      ROUTES.BUSINESSES_TRANSACTIONS_PAGE
    ),
    element: <BusinessTransactionPageRoute />,
  },
  {
    path: removeBasePathFromRoute(
      ROUTES_BASE.TRANSACTIONS,
      ROUTES.INDIVIDUALS_TRANSACTIONS_PAGE
    ),
    element: <IndividualTransactionsPageRoute />,
  },
  {
    path: removeBasePathFromRoute(
      ROUTES_BASE.TRANSACTIONS,
      ROUTES.BUSINESSES_TRANSACTIONS_PAGE
    ),
    element: <BusinessTransactionPageRoute />,
  },
  {
    path: removeBasePathFromRoute(
      ROUTES_BASE.TRANSACTIONS,
      ROUTES.TRANSACTION_DETAILS_PAGE
    ),
    element: <TransactionsDetailsPageRoute />,
  },
  {
    path: "*",
    element: <NotFoundContainer />,
  },
];

const BusinessSavingsPageRoute = memo(() => <BusinessesSavingsPageLazy />);
const BusinessesVaultSavingsDetailsPageRoute = memo(() => (
  <BusinessesVaultSavingsDetailsPageLazy />
));
const BusinessesFixedDepositsDetailsPageRoute = memo(() => (
  <BusinessesFixedDepositsDetailsPageLazy />
));

const BusinessCompliancePageRoute = memo(() => <BusinessCompliancePageLazy />);
const IndividualCompliancePageRoute = memo(() => (
  <IndividualCompliancePageLazy />
));

export const COMPLIANCE_ROUTES: IAppRoute[] = [
  // {
  //   path: removeBasePathFromRoute(
  //     ROUTES_BASE.COMPLIANCE,
  //     ROUTES.BUSINESSES_COMPLIANCE_PAGE
  //   ),
  //   element: <BusinessCompliancePageLazy />,
  // },
  {
    path: removeBasePathFromRoute(
      ROUTES_BASE.COMPLIANCE,
      ROUTES.BUSINESSES_COMPLIANCE_PAGE_READY_FOR_REVIEW
    ),
    element: <BusinessCompliancePageRoute />,
  },
  {
    path: removeBasePathFromRoute(
      ROUTES_BASE.COMPLIANCE,
      ROUTES.BUSINESSES_COMPLIANCE_PAGE_REJECTED
    ),
    element: <BusinessCompliancePageRoute />,
  },
  {
    path: removeBasePathFromRoute(
      ROUTES_BASE.COMPLIANCE,
      ROUTES.INDIVIDUALS_COMPLIANCE_PAGE_READY_FOR_REVIEW
    ),
    element: <IndividualCompliancePageRoute />,
  },
  {
    path: removeBasePathFromRoute(
      ROUTES_BASE.COMPLIANCE,
      ROUTES.INDIVIDUALS_COMPLIANCE_PAGE_REJECTED
    ),
    element: <IndividualCompliancePageRoute />,
  },
  // {
  //   path: removeBasePathFromRoute(
  //     ROUTES_BASE.COMPLIANCE,
  //     ROUTES.INDIVIDUALS_COMPLIANCE_PAGE
  //   ),
  //   element: <IndividualCompliancePageRoute />,
  // },
  {
    path: "*",
    element: <NotFoundContainer />,
  },
];

const BusinessesPageRoute = memo(() => <BusinessesPageLazy />);
const BusinessDetailsMainPageLazyRoute = memo(
  (props: IBusinessDetailsMainPageProps) => (
    <BusinessDetailsMainPageLazy {...props} />
  )
);
const BusinessTransactionLimitsPageRoute = memo(() => (
  <BusinessesProvider>
    <BusinessTransactionLimitsPageLazy />
  </BusinessesProvider>
));
const BusinessDetailsAccountTransactionsPageRoute = memo(() => (
  <BusinessDetailsAccountTransactionsPageLazy />
));
const AddNewBusinessPageLazyRoute = memo(() => <AddNewBusinessPageLazy />);
const UpdateBusinessTypePageLazyRoute = memo(() => (
  <UpdateBusinessTypePageLazy />
));
const ContinueBusinessRegistrationPageLazyRoute = memo(() => (
  <ContinueBusinessRegistrationPageLazy />
));

export const BUSINESSES_ROUTES: IAppRoute[] = [
  {
    path: removeBasePathFromRoute(
      ROUTES_BASE.BUSINESSES,
      ROUTES.BUSINESSES_PAGE
    ),
    element: <BusinessesPageRoute />,
  },
  {
    path: removeBasePathFromRoute(
      ROUTES_BASE.BUSINESSES,
      ROUTES.ADD_BUSINESSES_PAGE
    ),
    element: <AddNewBusinessPageLazyRoute />,
  },
  {
    path: removeBasePathFromRoute(
      ROUTES_BASE.BUSINESSES,
      ROUTES.UPDATE_BUSINESS_TYPE_PAGE
    ),
    element: <UpdateBusinessTypePageLazyRoute />,
  },
  {
    path: removeBasePathFromRoute(
      ROUTES_BASE.BUSINESSES,
      ROUTES.CONTINUE_BUSINESS_REGISTRATION_PAGE
    ),
    element: <ContinueBusinessRegistrationPageLazyRoute />,
  },
  {
    path: removeBasePathFromRoute(
      ROUTES_BASE.BUSINESSES,
      ROUTES.BUSINESS_DETAILS_PAGE
    ),
    element: (
      <BusinessDetailsMainPageLazyRoute
        businessDetailsCurrentTab={BusinessDetailsTabStatus.details}
      />
    ),
  },
  {
    path: removeBasePathFromRoute(
      ROUTES_BASE.BUSINESSES,
      ROUTES.BUSINESS_DETAILS_ACCOUNTS_PAGE
    ),
    element: (
      <BusinessDetailsMainPageLazyRoute
        businessDetailsCurrentTab={BusinessDetailsTabStatus.accounts}
      />
    ),
  },
  {
    path: removeBasePathFromRoute(
      ROUTES_BASE.BUSINESSES,
      ROUTES.BUSINESS_DETAILS_TRANSACTIONS_PAGE
    ),
    element: (
      <BusinessDetailsMainPageLazyRoute
        businessDetailsCurrentTab={BusinessDetailsTabStatus.transactions}
      />
    ),
  },
  {
    path: removeBasePathFromRoute(
      ROUTES_BASE.BUSINESSES,
      ROUTES.BUSINESS_DETAILS_YIELD_PAGE
    ),
    element: (
      <BusinessDetailsMainPageLazyRoute
        businessDetailsCurrentTab={BusinessDetailsTabStatus.yield}
      />
    ),
  },
  {
    path: removeBasePathFromRoute(
      ROUTES_BASE.BUSINESSES,
      ROUTES.BUSINESS_DETAILS_ADMINS_PAGE
    ),
    element: (
      <BusinessDetailsMainPageLazyRoute
        businessDetailsCurrentTab={BusinessDetailsTabStatus.admins}
      />
    ),
  },
  {
    path: removeBasePathFromRoute(
      ROUTES_BASE.BUSINESSES,
      ROUTES.BUSINESS_DETAILS_EMPLOYEES_PAGE
    ),
    element: (
      <BusinessDetailsMainPageLazyRoute
        businessDetailsCurrentTab={BusinessDetailsTabStatus.employees}
      />
    ),
  },
  {
    path: removeBasePathFromRoute(
      ROUTES_BASE.BUSINESSES,
      ROUTES.BUSINESS_DETAILS_ODP_PAGE
    ),
    element: (
      <BusinessDetailsMainPageLazyRoute
        businessDetailsCurrentTab={BusinessDetailsTabStatus["on-demand-pay"]}
      />
    ),
  },
  {
    path: removeBasePathFromRoute(
      ROUTES_BASE.BUSINESSES,
      ROUTES.BUSINESS_DETAILS_PAYROLL_PAGE
    ),
    element: (
      <BusinessDetailsMainPageLazyRoute
        businessDetailsCurrentTab={BusinessDetailsTabStatus.payroll}
      />
    ),
  },
  {
    path: removeBasePathFromRoute(
      ROUTES_BASE.BUSINESSES,
      ROUTES.BUSINESS_TRANSACTION_LIMIT_PAGE
    ),
    element: <BusinessTransactionLimitsPageRoute />,
  },
  {
    path: removeBasePathFromRoute(
      ROUTES_BASE.BUSINESSES,
      ROUTES.BUSINESS_DETAILS_ACCOUNTS_TRANSACTIONS_PAGE
    ),
    element: (
      <BusinessesProvider>
        <BusinessDetailsAccountTransactionsPageRoute />
      </BusinessesProvider>
    ),
  },
  {
    path: "*",
    element: <NotFoundContainer />,
  },
];

const IndividualsPageRoute = memo(() => <IndividualsPageLazy />);
// const IndividualDetailsPageRoute = memo(() => <IndividualDetailsPageLazy />);
const IndividualDetailsMainPageLazyRoute = memo(
  (props: IIndividualDetailsMainPageProps) => (
    <IndividualDetailsMainPageLazy {...props} />
  )
);
const IndividualViewLoanDetailsPageRoute = memo(() => (
  <IndividualViewLoanDetailsPageLazy />
));
const IndividualViewSavingDetailsPageRoute = memo(() => (
  <IndividualViewSavingDetailsPageLazy />
));
const IndividualViewSavingsHistoryPageRoute = memo(() => (
  <IndividualViewSavingsHistoryPageLazy />
));
const IndividualViewWithdrawalHistoryPageRoute = memo(() => (
  <IndividualViewWithdrawalHistoryPageLazy />
));
const IndividualAccountTransactionDetailsPageRoute = memo(() => (
  <IndividualAccountTransactionDetailsPageLazy />
));
const IndividualAccountViewTransactionDetailsPageRoute = memo(() => (
  <IndividualAccountViewTransactionDetailsPageLazy />
));
const IndividualTransactionViewTransactionDetailsPageRoute = memo(() => (
  <IndividualTransactionsViewTransactionDetailsPageLazy />
));

export const INDIVIDUAL_ROUTES: IAppRoute[] = [
  {
    path: removeBasePathFromRoute(
      ROUTES_BASE.INDIVIDUALS,
      ROUTES.INDIVIDUALS_PAGE
    ),
    element: <IndividualsPageRoute />,
  },
  {
    path: removeBasePathFromRoute(
      ROUTES_BASE.INDIVIDUALS,
      ROUTES.INDIVIDUALS_DETAILS_PAGE
    ),
    element: (
      <IndividualDetailsMainPageLazyRoute
        individualDetailsCurrentTab={IndividualDetailsTabStatus.details}
      />
    ),
  },
  {
    path: removeBasePathFromRoute(
      ROUTES_BASE.INDIVIDUALS,
      ROUTES.INDIVIDUALS_ACCOUNT_DETAILS_PAGE
    ),
    element: (
      <IndividualDetailsMainPageLazyRoute
        individualDetailsCurrentTab={IndividualDetailsTabStatus.account}
      />
    ),
  },
  {
    path: removeBasePathFromRoute(
      ROUTES_BASE.INDIVIDUALS,
      ROUTES.INDIVIDUALS_TRANSACTIONS_DETAILS_PAGE
    ),
    element: (
      <IndividualDetailsMainPageLazyRoute
        individualDetailsCurrentTab={IndividualDetailsTabStatus.transactions}
      />
    ),
  },
  {
    path: removeBasePathFromRoute(
      ROUTES_BASE.INDIVIDUALS,
      ROUTES.INDIVIDUALS_LOANS_DETAILS_PAGE
    ),
    element: (
      <IndividualDetailsMainPageLazyRoute
        individualDetailsCurrentTab={IndividualDetailsTabStatus.loans}
      />
    ),
  },
  {
    path: removeBasePathFromRoute(
      ROUTES_BASE.INDIVIDUALS,
      ROUTES.INDIVIDUALS_SAVINGS_DETAILS_PAGE
    ),
    element: (
      <IndividualDetailsMainPageLazyRoute
        individualDetailsCurrentTab={IndividualDetailsTabStatus.savings}
      />
    ),
  },
  {
    path: removeBasePathFromRoute(
      ROUTES_BASE.INDIVIDUALS,
      ROUTES.INDIVIDUALS_ON_DEMAND_PAY_DETAILS_PAGE
    ),
    element: (
      <IndividualDetailsMainPageLazyRoute
        individualDetailsCurrentTab={
          IndividualDetailsTabStatus["on-demand-pay"]
        }
      />
    ),
  },
  // {
  //   path: removeBasePathFromRoute(
  //     ROUTES_BASE.INDIVIDUALS,
  //     ROUTES.INDIVIDUALS_DETAILS_PAGE
  //   ),
  //   element: <IndividualDetailsPageRoute />,
  // },
  // {
  //   path: removeBasePathFromRoute(
  //     ROUTES_BASE.INDIVIDUALS,
  //     ROUTES.INDIVIDUALS_ACCOUNT_DETAILS_PAGE
  //   ),
  //   element: <IndividualAccountDetailsPageRoute />,
  // },
  {
    path: removeBasePathFromRoute(
      ROUTES_BASE.INDIVIDUALS,
      ROUTES.INDIVIDUALS_ACCOUNT_VIEW_TRANSACTION_DETAILS_PAGE
    ),
    element: <IndividualAccountViewTransactionDetailsPageRoute />,
  },
  {
    path: removeBasePathFromRoute(
      ROUTES_BASE.INDIVIDUALS,
      ROUTES.INDIVIDUALS_TRANSACTION_VIEW_TRANSACTION_DETAILS_PAGE
    ),
    element: <IndividualTransactionViewTransactionDetailsPageRoute />,
  },
  {
    path: removeBasePathFromRoute(
      ROUTES_BASE.INDIVIDUALS,
      ROUTES.INDIVIDUALS_ACCOUNT_TRANSACTION_DETAILS_PAGE
    ),
    element: <IndividualAccountTransactionDetailsPageRoute />,
  },
  {
    path: removeBasePathFromRoute(
      ROUTES_BASE.INDIVIDUALS,
      ROUTES.INDIVIDUAL_VIEW_LOAN_DETAILS_PAGE
    ),
    element: <IndividualViewLoanDetailsPageRoute />,
  },
  {
    path: removeBasePathFromRoute(
      ROUTES_BASE.INDIVIDUALS,
      ROUTES.INDIVIDUAL_VIEW_SAVING_DETAILS_PAGE
    ),
    element: <IndividualViewSavingDetailsPageRoute />,
  },
  {
    path: removeBasePathFromRoute(
      ROUTES_BASE.INDIVIDUALS,
      ROUTES.INDIVIDUAL_VIEW_SAVINGS_HISTORY_PAGE
    ),
    element: <IndividualViewSavingsHistoryPageRoute />,
  },
  {
    path: removeBasePathFromRoute(
      ROUTES_BASE.INDIVIDUALS,
      ROUTES.INDIVIDUAL_VIEW_WITHDRAWAL_HISTORY_PAGE
    ),
    element: <IndividualViewWithdrawalHistoryPageRoute />,
  },
  {
    path: "*",
    element: <NotFoundContainer />,
  },
];

const IndividualSavingsPageRoute = memo(() => <IndividualsSavingsPageLazy />);
const IndividualSavingsFlexViewDetailsPageRoute = memo(() => (
  <IndividualsSavingsFlexViewDetailsPageLazy />
));

const IndividualSavingsFlexViewHistoryPageRoute = memo(() => (
  <IndividualsSavingsFlexViewHistoryPageLazy />
));

const IndividualSavingsGoalViewDetailsPageRoute = memo(() => (
  <IndividualsSavingsGoalViewDetailsPageLazy />
));
const IndividualSavingsGoalViewHistoryPageRoute = memo(() => (
  <IndividualsSavingsGoalViewHistoryPageLazy />
));

const IndividualSavingsVaultViewDetailsPageRoute = memo(() => (
  <IndividualsSavingsVaultViewDetailsPageLazy />
));

const IndividualSavingsVaultViewHistoryPageRoute = memo(() => (
  <IndividualsSavingsVaultViewHistoryPageLazy />
));

const BusinessesVaultSavingsHistoryPageRoute = memo(() => (
  <BusinessesVaultSavingsHistoryPageLazy />
));
const BusinessesFixedDepositsHistoryPageRoute = memo(() => (
  <BusinessesFixedDepositsHistoryPageLazy />
));

export const SAVINGS_ROUTES: IAppRoute[] = [
  {
    path: removeBasePathFromRoute(
      ROUTES_BASE.SAVINGS,
      ROUTES.BUSINESSES_SAVINGS_PAGE
    ),
    element: <BusinessSavingsPageRoute />,
  },
  {
    path: removeBasePathFromRoute(
      ROUTES_BASE.SAVINGS,
      ROUTES.INDIVIDUALS_SAVINGS_PAGE
    ),
    element: <IndividualSavingsPageRoute />,
  },
  {
    path: removeBasePathFromRoute(
      ROUTES_BASE.SAVINGS,
      ROUTES.BUSINESSES_VAULT_SAVINGS_DETAILS_PAGE
    ),
    element: <BusinessesVaultSavingsDetailsPageRoute />,
  },
  {
    path: removeBasePathFromRoute(
      ROUTES_BASE.SAVINGS,
      ROUTES.BUSINESSES_FIXED_DEPOSITS_DETAILS_PAGE
    ),
    element: <BusinessesFixedDepositsDetailsPageRoute />,
  },
  {
    path: removeBasePathFromRoute(
      ROUTES_BASE.SAVINGS,
      ROUTES.BUSINESSES_VAULT_SAVINGS_HISTORY_PAGE
    ),
    element: <BusinessesVaultSavingsHistoryPageRoute />,
  },
  {
    path: removeBasePathFromRoute(
      ROUTES_BASE.SAVINGS,
      ROUTES.BUSINESSES_FIXED_DEPOSITS_HISTORY_PAGE
    ),
    element: <BusinessesFixedDepositsHistoryPageRoute />,
  },
  {
    path: removeBasePathFromRoute(
      ROUTES_BASE.SAVINGS,
      ROUTES.INDIVIDUALS_FLEX_SAVINGS_VIEW_DETAILS_PAGE
    ),
    element: <IndividualSavingsFlexViewDetailsPageRoute />,
    // element: <IndividualViewSavingDetailsPageRoute />,
  },
  {
    path: removeBasePathFromRoute(
      ROUTES_BASE.SAVINGS,
      ROUTES.INDIVIDUALS_FLEX_SAVINGS_VIEW_HISTORY_PAGE
    ),
    element: <IndividualSavingsFlexViewHistoryPageRoute />,
    // element: <IndividualViewSavingsHistoryPageRoute />,
  },
  {
    path: removeBasePathFromRoute(
      ROUTES_BASE.SAVINGS,
      ROUTES.INDIVIDUALS_GOAL_SAVINGS_VIEW_DETAILS_PAGE
    ),
    element: <IndividualSavingsGoalViewDetailsPageRoute />,
    // element: <IndividualViewSavingDetailsPageRoute />,
  },
  {
    path: removeBasePathFromRoute(
      ROUTES_BASE.SAVINGS,
      ROUTES.INDIVIDUALS_GOAL_SAVINGS_VIEW_HISTORY_PAGE
    ),
    element: <IndividualSavingsGoalViewHistoryPageRoute />,
    // element: <IndividualViewSavingsHistoryPageRoute />,
  },
  {
    path: removeBasePathFromRoute(
      ROUTES_BASE.SAVINGS,
      ROUTES.INDIVIDUALS_VAULT_SAVINGS_VIEW_DETAILS_PAGE
    ),
    element: <IndividualSavingsVaultViewDetailsPageRoute />,
  },
  {
    path: removeBasePathFromRoute(
      ROUTES_BASE.SAVINGS,
      ROUTES.INDIVIDUALS_VAULT_SAVINGS_VIEW_HISTORY_PAGE
    ),
    element: <IndividualSavingsVaultViewHistoryPageRoute />,
  },
  {
    path: "*",
    element: <NotFoundContainer />,
  },
];
